import { Helmet } from 'react-helmet';
import Header from '../../../components/Header/Header';
import { GetString } from '../../../components/StringResourceManager';
import { APP_TITLE } from '../../../utils/constants';
import { makeStyles, Paper, Theme, createStyles } from '@material-ui/core';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import React from 'react';
import {
  LocaleInterface,
  locales,
} from '../../../components/AlertsGrid/GridLocale';
import { ApplicationState } from '../../../store';
import FirmwareGrid from '../../../components/Devices/Firmware/FirmwareGrid';
import { Dispatch } from 'redux';
import { getAssetCategoryList } from '../../../store/Assets/AssetsActions';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-start',
      '& > *': {
        margin: theme.spacing(2),
      },
    },
    paperGrid: {
      marginTop: theme.spacing(7),
      display: 'flex',
      overflow: 'auto',
      flexDirection: 'column',
    },
  }),
);

export default function FirmwareSubMenu() {
  const classes = useStyles();

  const selectedLanguage: string = useSelector(
    (state: ApplicationState) => state.userSettingsReducer.selectedLanguage,
  );

  const [currentLocale, setCurrentLocale] = React.useState<LocaleInterface>(
    locales[0],
  );

  const isLogin: boolean = useSelector(
    (state: ApplicationState) => state.userSessionReducer.isLoggedIn,
  );
  const dispatch: Dispatch<any> = useDispatch();

  useEffect(() => {
    if (isLogin) {
      getAssetCategoryList(dispatch);
    }
    return () => {};
  }, [isLogin]);

  useEffect(() => {
    if (selectedLanguage == 'English') {
      setCurrentLocale(locales[0]);
    } else if (selectedLanguage == 'French') {
      setCurrentLocale(locales[1]);
    }
  }, [selectedLanguage]);

  return (
    <>
      <Helmet>
        <title>
          {GetString('PAGE_TITLE_DEVICE_FIRMWARE')} | {APP_TITLE}
        </title>
      </Helmet>
      <Header
        open={true}
        pageDisplayed={GetString('PAGE_TITLE_DEVICE_FIRMWARE')}
      />
      <Paper className={classes.paperGrid}>
        <FirmwareGrid />
      </Paper>
    </>
  );
}
